// Hero Banner #3 - Video Control with enhanced mobile support
function tptHeroBannerPauseAllVideo() {
	document.querySelectorAll('.tpt-hero-banner-video-main').forEach((video) => {
		video.pause();
		video.currentTime = 0; // Reset video on mobile
	});
}

function tptHeroBannerMutedAllVideo() {
	document.querySelectorAll('.tpt-hero-banner-video-main').forEach((video) => (video.muted = true));
}

// Detect mobile device
function isMobileDevice() {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
		   window.innerWidth <= 767;
}

if (!customElements.get('tpt-hero-banner-video-item')) {
	customElements.define(
		'tpt-hero-banner-video-item',
		class TptHeroBannerVideoItem extends HTMLElement {
			constructor() {
				super();

				this.playBtn = this.querySelector('tpt-hero-banner-play-video');
				this.pauseBtn = this.querySelector('tpt-hero-banner-pause-video');
				this.videoContainer = this.querySelector('.hero-banner-3_video');
				this.isMobile = isMobileDevice();
				
				if (this.playBtn) {
					this.playBtn.addEventListener('click', this.playVideo.bind(this));
					// Add touch events for better mobile support
					this.playBtn.addEventListener('touchend', (e) => {
						e.preventDefault();
						this.playVideo();
					});
				}
				
				if (this.pauseBtn) {
					this.pauseBtn.addEventListener('click', this.pauseVideo.bind(this));
					// Add touch events for better mobile support
					this.pauseBtn.addEventListener('touchend', (e) => {
						e.preventDefault();
						this.pauseVideo();
					});
				}

				// Add click/touch event to video container for play/pause toggle
				if (this.videoContainer) {
					this.videoContainer.addEventListener('click', (e) => {
						// Check if click is on pause button or play button
						if (e.target.closest('tpt-hero-banner-pause-video') || e.target.closest('tpt-hero-banner-play-video')) {
							return; // Let the button handle the click
						}
						
						// Toggle play/pause when clicking on video area
						if (this.classList.contains('loaded')) {
							this.pauseVideo();
						} else {
							this.playVideo();
						}
					});

					// Add touch support for mobile
					this.videoContainer.addEventListener('touchend', (e) => {
						// Prevent both click and touchend from firing
						e.preventDefault();
						
						// Check if touch is on pause button or play button
						if (e.target.closest('tpt-hero-banner-pause-video') || e.target.closest('tpt-hero-banner-play-video')) {
							return; // Let the button handle the touch
						}
						
						// Toggle play/pause when touching video area
						if (this.classList.contains('loaded')) {
							this.pauseVideo();
						} else {
							this.playVideo();
						}
					});
				}

				// Set up video element event listeners
				this.setupVideoElement();
			}

			setupVideoElement() {
				const video = this.querySelector('.tpt-hero-banner-video-main');
				if (video) {
					// Handle mobile autoplay restrictions
					video.addEventListener('loadedmetadata', () => {
						if (this.isMobile) {
							video.muted = true; // Ensure muted for mobile autoplay
						}
					});

					// Handle video ended event for mobile
					video.addEventListener('ended', () => {
						this.pauseVideo();
						// Reset video to beginning on mobile
						if (this.isMobile) {
							video.currentTime = 0;
						}
					});

					// Handle mobile-specific events
					if (this.isMobile) {
						video.addEventListener('canplay', () => {
							video.style.visibility = 'visible';
							video.style.opacity = '1';
						});
					}
				}
			}

			playVideo() {
				// If video is already playing, pause it
				if (this.classList.contains('loaded')) {
					this.pauseVideo();
					return;
				}

				tptHeroBannerMutedAllVideo();

				document.querySelectorAll('tpt-hero-banner-play-video').forEach((playBtn) => {
					playBtn.classList.remove('active');
				});

				/**
				 * Pause all videos if only one video mode is enabled
				 */
				if (this.closest('tpt-hero-banner-video-group[data-only-one-video="true"]')) {
					this.closest('tpt-hero-banner-video-group')
						.querySelectorAll('.tpt-hero-banner-video-main')
						.forEach((video) => {
							video.pause();
							if (this.isMobile) {
								video.currentTime = 0;
							}
						});
				}

				/**
				 * Set all video items to default state
				 */
				document.querySelectorAll('tpt-hero-banner-video-item').forEach((item) => {
					item.classList.remove('loaded');

					const videoMain = item.querySelector('.tpt-hero-banner-video-main');
					if (videoMain) {
						videoMain.classList.remove('active');
						videoMain.pause();
						if (this.isMobile) {
							videoMain.currentTime = 0;
						}
					}
				});

				/**
				 * Activate current video item
				 */
				this.classList.add('loaded');
				const mainVideo = this.querySelector('.tpt-hero-banner-video-main');
				if (mainVideo) {
					mainVideo.classList.add('active');
					
					// Enhanced mobile video play handling
					const playPromise = mainVideo.play();
					if (playPromise !== undefined) {
						playPromise.then(() => {
							// Video started playing successfully
							if (!this.isMobile) {
								mainVideo.muted = false; // Unmute on desktop only
							}
						}).catch((error) => {
							// Auto-play was prevented (common on mobile)
							console.warn('Video autoplay prevented:', error);
							// Keep the video muted and ready for user interaction
							mainVideo.muted = true;
						});
					}
				}

				if (this.playBtn) {
					this.playBtn.classList.add('active');
				}

				/**
				 * Handle other sections when not in one-video mode
				 */
				if (!this.closest('tpt-hero-banner-video-group[data-only-one-video="true"]')) {
					const groupVideoOneTime = document.querySelectorAll('tpt-hero-banner-video-group[data-only-one-video="true"]');

					if (groupVideoOneTime) {
						groupVideoOneTime.forEach((group) => {
							const itemVideos = group.querySelectorAll('tpt-hero-banner-video-item');

							itemVideos.forEach((item) => {
								const videos = item.querySelectorAll('.tpt-hero-banner-video-main');

								if (videos.length >= 1) {
									const playPromise = videos[0].play();
									if (playPromise !== undefined) {
										playPromise.then(() => {
											videos[0].muted = true;
										}).catch(() => {
											videos[0].muted = true;
										});
									}
								}
							});
						});
					}
				}
			}

			pauseVideo() {
				const mainVideo = this.querySelector('.tpt-hero-banner-video-main');
				if (mainVideo) {
					mainVideo.classList.remove('active');
					mainVideo.pause();
					mainVideo.muted = true;
					// Reset to beginning on mobile for better UX
					if (this.isMobile) {
						mainVideo.currentTime = 0;
					}
				}

				if (this.playBtn) {
					this.playBtn.classList.remove('active');
				}
				
				this.classList.remove('loaded');
			}
		}
	);
}

if (!customElements.get('tpt-hero-banner-play-video')) {
	customElements.define(
		'tpt-hero-banner-play-video',
		class TptHeroBannerPlayVideo extends HTMLElement {
			constructor() {
				super();
				
				// Make element focusable for accessibility
				this.setAttribute('tabindex', '0');
				this.setAttribute('role', 'button');
				this.setAttribute('aria-label', 'Play video');
				
				// Handle keyboard events
				this.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						this.click();
					}
				});

				// Prevent default touch behavior on mobile
				this.addEventListener('touchstart', (e) => {
					e.preventDefault();
				});
			}
		}
	);
}

if (!customElements.get('tpt-hero-banner-pause-video')) {
	customElements.define(
		'tpt-hero-banner-pause-video',
		class TptHeroBannerPauseVideo extends HTMLElement {
			constructor() {
				super();
				
				// Make element focusable for accessibility
				this.setAttribute('tabindex', '0');
				this.setAttribute('role', 'button');
				this.setAttribute('aria-label', 'Pause video');
				
				// Handle keyboard events
				this.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						this.click();
					}
				});

				// Prevent default touch behavior on mobile
				this.addEventListener('touchstart', (e) => {
					e.preventDefault();
				});
			}
		}
	);
}

if (!customElements.get('tpt-hero-banner-video-group')) {
	customElements.define(
		'tpt-hero-banner-video-group',
		class TptHeroBannerVideoGroup extends HTMLElement {
			constructor() {
				super();
				this.isMobile = isMobileDevice();
			}

			connectedCallback() {
				// Initialize video states when connected
				this.initializeVideos();
				
				// Set up swiper integration with mobile-specific timing
				const delay = this.isMobile ? 1000 : 500;
				setTimeout(() => {
					this.setupSwiperIntegration();
				}, delay);
			}

			initializeVideos() {
				const videoItems = this.querySelectorAll('tpt-hero-banner-video-item');
				
				videoItems.forEach((item) => {
					const video = item.querySelector('.tpt-hero-banner-video-main');
					if (video) {
						// Set up video event listeners
						this.setupVideoEvents(video, item);
						
						// Mobile-specific video setup
						if (this.isMobile) {
							video.setAttribute('playsinline', 'true');
							video.setAttribute('webkit-playsinline', 'true');
							video.muted = true;
							
							// Ensure video is visible on mobile
							video.style.display = 'block';
							video.style.width = '100%';
							video.style.height = '100%';
						}
					}
				});
			}

			setupSwiperIntegration() {
				const swiperContainer = this.querySelector('.tpt-swiper-container');
				if (swiperContainer && swiperContainer.swiper) {
					const swiper = swiperContainer.swiper;
					
					// Pause videos when slide changes
					swiper.on('slideChange', () => {
						// Pause all videos
						this.querySelectorAll('tpt-hero-banner-video-item').forEach(item => {
							if (item.pauseVideo) {
								item.pauseVideo();
							}
						});
					});

					// Mobile-specific swiper events
					if (this.isMobile) {
						// Ensure pagination is visible
						const pagination = swiperContainer.querySelector('.tpt-swiper-paginations');
						if (pagination) {
							pagination.style.display = 'flex';
						}

						// Handle touch events properly on mobile
						swiper.on('touchStart', () => {
							// Pause all videos when user starts swiping
							this.querySelectorAll('tpt-hero-banner-video-item').forEach(item => {
								if (item.pauseVideo) {
									item.pauseVideo();
								}
							});
						});
					}

					// Auto-play first video if setting is enabled
					if (this.dataset.autoPlayFirst === 'true') {
						const autoPlayDelay = this.isMobile ? 2000 : 1000;
						setTimeout(() => {
							const firstVideoItem = this.querySelector('tpt-hero-banner-video-item');
							if (firstVideoItem && firstVideoItem.playVideo) {
								firstVideoItem.playVideo();
							}
						}, autoPlayDelay);
					}
				} else {
					// Retry if swiper not ready yet
					setTimeout(() => {
						this.setupSwiperIntegration();
					}, 1000);
				}
			}

			setupVideoEvents(video, videoItem) {
				// Handle video errors
				video.addEventListener('error', (e) => {
					console.warn('Hero banner video failed to load:', e);
					videoItem.style.opacity = '0.5';
				});

				// Prevent video controls on mobile
				video.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
				});

				// Disable context menu
				video.addEventListener('contextmenu', (e) => {
					e.preventDefault();
				});

				// Handle video loading
				video.addEventListener('loadeddata', () => {
					videoItem.style.opacity = '1';
					
					// Mobile-specific handling
					if (this.isMobile) {
						video.style.visibility = 'visible';
					}
				});

				// Handle video pause
				video.addEventListener('pause', () => {
					if (videoItem.classList.contains('loaded')) {
						// Video was paused, update states
						videoItem.classList.remove('loaded');
						const playBtn = videoItem.querySelector('tpt-hero-banner-play-video');
						if (playBtn) {
							playBtn.classList.remove('active');
						}
					}
				});

				// Handle video play
				video.addEventListener('play', () => {
					if (!videoItem.classList.contains('loaded')) {
						videoItem.classList.add('loaded');
						const playBtn = videoItem.querySelector('tpt-hero-banner-play-video');
						if (playBtn) {
							playBtn.classList.add('active');
						}
					}
				});

				// Handle video time update for progress tracking
				video.addEventListener('timeupdate', () => {
					if (video.duration > 0) {
						const progress = (video.currentTime / video.duration) * 100;
						// Could be used for progress indicators if needed
						videoItem.style.setProperty('--video-progress', `${progress}%`);
					}
				});

				// Mobile-specific video events
				if (this.isMobile) {
					video.addEventListener('canplay', () => {
						// Ensure video is ready for mobile playback
						video.setAttribute('preload', 'metadata');
					});

					// Handle mobile video stalling
					video.addEventListener('stalled', () => {
						console.warn('Video stalled on mobile, attempting recovery');
						video.load();
					});
				}
			}
		}
	);
}

// Global cleanup functions
window.tptHeroBannerPauseAllVideo = tptHeroBannerPauseAllVideo;
window.tptHeroBannerMutedAllVideo = tptHeroBannerMutedAllVideo;

// Handle page visibility changes
document.addEventListener('visibilitychange', () => {
	if (document.hidden) {
		// Pause all videos when page becomes hidden
		tptHeroBannerPauseAllVideo();
	}
});

// Enhanced intersection observer for mobile performance
if ('IntersectionObserver' in window) {
	const videoObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const videoItem = entry.target;
			if (!entry.isIntersecting) {
				// Pause videos that are out of view
				if (videoItem.pauseVideo) {
					videoItem.pauseVideo();
				}
			} else {
				// Ensure video is visible when in view (mobile fix)
				const video = videoItem.querySelector('.tpt-hero-banner-video-main');
				if (video && isMobileDevice()) {
					video.style.display = 'block';
					video.style.opacity = '1';
				}
			}
		});
	}, {
		threshold: isMobileDevice() ? 0.3 : 0.1, // Higher threshold on mobile
		rootMargin: isMobileDevice() ? '50px' : '100px'
	});

	// Observe video items when they're added
	setTimeout(() => {
		document.querySelectorAll('tpt-hero-banner-video-item').forEach(item => {
			videoObserver.observe(item);
		});
	}, 1000);
}

// Mobile-specific initialization
if (isMobileDevice()) {
	document.addEventListener('DOMContentLoaded', () => {
		// Ensure all videos are properly configured for mobile
		setTimeout(() => {
			document.querySelectorAll('.tpt-hero-banner-video-main').forEach(video => {
				video.setAttribute('playsinline', 'true');
				video.setAttribute('webkit-playsinline', 'true');
				video.muted = true;
				video.style.width = '100%';
				video.style.height = '100%';
				video.style.objectFit = 'cover';
			});
		}, 500);
	});

	// Handle mobile orientation changes
	window.addEventListener('orientationchange', () => {
		setTimeout(() => {
			// Recalculate video dimensions after orientation change
			document.querySelectorAll('.hero-banner-3_video').forEach(container => {
				container.style.height = 'var(--video-height-mobile)';
			});
		}, 500);
	});
}

// Handle Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
	document.addEventListener('shopify:section:load', () => {
		// Re-initialize custom elements when sections are loaded in theme editor
		setTimeout(() => {
			const heroBannerGroups = document.querySelectorAll('tpt-hero-banner-video-group');
			heroBannerGroups.forEach(group => {
				if (group.initializeVideos) {
					group.initializeVideos();
				}
				if (group.setupSwiperIntegration) {
					group.setupSwiperIntegration();
				}
			});
		}, 100);
	});

	document.addEventListener('shopify:section:unload', () => {
		// Pause all videos when section is unloaded
		tptHeroBannerPauseAllVideo();
	});

	document.addEventListener('shopify:section:select', () => {
		// Pause all videos when another section is selected
		tptHeroBannerPauseAllVideo();
	});

	document.addEventListener('shopify:block:select', (e) => {
		// Auto-play video when block is selected in theme editor
		const videoItem = e.target.querySelector('tpt-hero-banner-video-item');
		if (videoItem && videoItem.playVideo) {
			setTimeout(() => {
				videoItem.playVideo();
			}, 500);
		}
	});

	document.addEventListener('shopify:block:deselect', (e) => {
		// Pause video when block is deselected in theme editor
		const videoItem = e.target.querySelector('tpt-hero-banner-video-item');
		if (videoItem && videoItem.pauseVideo) {
			videoItem.pauseVideo();
		}
	});
}